import { mapIntegrationProviderFromDTO } from '@/modules/common/mappers/integration.mapper';

import { Client } from '../types/client';
import { ClientSummaryResponse } from '../types/dto/response/client-summary-response';
import { mapClientManagerFromResponse } from './client-manager.mapper';
import { mapClientPaymentTermsFromDTO } from './client-payment-terms.mapper';
import { mapClientStatusFromDTO } from './client-status.mapper';

/**
 * Maps a single ClientSummaryResponse (API format) to Client (domain model)
 */
export const mapClientSummaryFromResponse = (response: ClientSummaryResponse): Client => {
  return {
    id: String(response.id),
    name: response.name,
    logo: response.logoUrl ?? undefined,
    email: response.email,
    manager: response.manager ? mapClientManagerFromResponse(response.manager) : undefined,
    status: mapClientStatusFromDTO(response.status),
    paymentTerms: mapClientPaymentTermsFromDTO(response.defaultPaymentTerms),
    integrations: response.connectedIntegrations.map(integration => ({
      id: mapIntegrationProviderFromDTO(integration),
      type: mapIntegrationProviderFromDTO(integration),
      icon: '',
      clients: null,
      selectedValue: null,
    })),
  };
};

/**
 * Maps array of ClientSummaryResponse to array of Client
 */
export const mapClientSummaries = (responses: ClientSummaryResponse[]): Client[] => {
  return responses.map(mapClientSummaryFromResponse);
};
